<template>
  <v-container id="master-rekap-bencana" fluid tag="section" class="cyber-page">
    <v-row>
      <v-col cols="12" md="6">
        <base-material-card color="#018C74" icon="mdi-alert-decagram" class="glass-card">
          <template v-slot:heading>
            <div class="display-1 font-weight-black cyber-text">
              REKAPITULASI KEJADIAN BENCANA
            </div>
            <div class="subtitle-2 secondary-text">
              Input Detail Kejadian, Dampak, dan Korban
            </div>
          </template>

          <v-form ref="form" class="mt-4">
            <v-tabs
              v-model="tab"
              background-color="transparent"
              color="#CFA22D"
              grow
              class="mb-4"
            >
              <v-tab><v-icon left>mdi-information</v-icon> Utama</v-tab>
              <v-tab><v-icon left>mdi-home-city</v-icon> Kerusakan</v-tab>
              <v-tab><v-icon left>mdi-account-group</v-icon> Korban</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab" class="transparent-tabs">
              <v-tab-item>
                <v-row dense>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="editedItem.tanggal"
                      label="Tanggal Kejadian"
                      type="date"
                      outlined
                      color="#018C74"
                      prepend-inner-icon="mdi-calendar"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="editedItem.jenis_kejadian"
                      label="Jenis Kejadian"
                      outlined
                      color="#018C74"
                    />
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-autocomplete
                      v-model="editedItem.kecamatan_bps"
                      :items="kecamatanOptions"
                      item-text="nama_kecamatan"
                      item-value="kode_bps"
                      label="Kecamatan (BPS)"
                      outlined
                      color="#018C74"
                      clearable
                      placeholder="Pilih Kecamatan..."
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-autocomplete
                      v-model="editedItem.desa_bps"
                      :items="filteredVillageOptions"
                      item-text="desa"
                      item-value="kode_bps"
                      label="Desa (BPS)"
                      outlined
                      color="#018C74"
                      :disabled="!editedItem.kecamatan_bps"
                      :placeholder="
                        editedItem.kecamatan_bps
                          ? 'Pilih Desa...'
                          : 'Pilih kecamatan dahulu'
                      "
                      no-data-text="Data desa tidak ditemukan"
                      clearable
                    >
                      <template v-slot:item="data">
                        <v-list-item-content>
                          <v-list-item-title style="color: #018c74; font-size: 14px">{{
                            data.item.desa
                          }}</v-list-item-title>
                          <v-list-item-subtitle style="color: #cfa22d; font-size: 10px">{{
                            data.item.nama_kecamatan
                          }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field
                      v-model="editedItem.jalan_dusun_rt_rw"
                      label="Detail Lokasi (Dusun/RT/RW)"
                      outlined
                      color="#018C74"
                      prepend-inner-icon="mdi-map-marker-distance"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="editedItem.koordinat"
                      label="Koordinat Geospasial"
                      outlined
                      color="#CFA22D"
                      prepend-inner-icon="mdi-target-variant"
                      class="cyber-coord-field"
                      readonly
                    />
                  </v-col>
                </v-row>
              </v-tab-item>

              <v-tab-item>
                <v-row dense>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="editedItem.rumah_rusak_berat"
                      label="Rumah Rusak Berat"
                      type="number"
                      outlined
                      color="#018C74"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="editedItem.rumah_rusak_sedang"
                      label="Rumah Rusak Sedang"
                      type="number"
                      outlined
                      color="#018C74"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="editedItem.rumah_rusak_ringan"
                      label="Rumah Rusak Ringan"
                      type="number"
                      outlined
                      color="#018C74"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="editedItem.jumlah_rumah_rusak"
                      label="Total Rumah Rusak"
                      type="number"
                      outlined
                      color="#CFA22D"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="editedItem.hutan_lahan_ha"
                      label="Luas Lahan (HA)"
                      type="number"
                      outlined
                      color="#018C74"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="editedItem.jumlah_kios"
                      label="Jumlah Kios/Toko"
                      type="number"
                      outlined
                      color="#018C74"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="editedItem.taksiran_kerugian"
                      label="Taksiran Kerugian (Rp)"
                      type="number"
                      outlined
                      color="#CFA22D"
                    />
                  </v-col>
                </v-row>
              </v-tab-item>

              <v-tab-item>
                <v-row dense>
                  <v-col cols="4"
                    ><v-text-field
                      v-model="editedItem.meninggal"
                      label="Meninggal"
                      type="number"
                      outlined
                      color="#ff5252"
                  /></v-col>
                  <v-col cols="4"
                    ><v-text-field
                      v-model="editedItem.luka"
                      label="Luka-luka"
                      type="number"
                      outlined
                      color="#018C74"
                  /></v-col>
                  <v-col cols="4"
                    ><v-text-field
                      v-model="editedItem.terdampak_kk"
                      label="Terdampak (KK)"
                      type="number"
                      outlined
                      color="#018C74"
                  /></v-col>

                  <v-divider class="my-2 border-neon" style="width: 100%"></v-divider>

                  <v-col cols="6"
                    ><v-text-field
                      v-model="editedItem.jiwa_pria"
                      label="Jiwa Pria"
                      type="number"
                      dense
                      outlined
                  /></v-col>
                  <v-col cols="6"
                    ><v-text-field
                      v-model="editedItem.jiwa_perempuan"
                      label="Jiwa Perempuan"
                      type="number"
                      dense
                      outlined
                  /></v-col>
                  <v-col cols="6"
                    ><v-text-field
                      v-model="editedItem.lansia_pria"
                      label="Lansia Pria"
                      type="number"
                      dense
                      outlined
                  /></v-col>
                  <v-col cols="6"
                    ><v-text-field
                      v-model="editedItem.lansia_wanita"
                      label="Lansia Wanita"
                      type="number"
                      dense
                      outlined
                  /></v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>

            <v-card-actions class="px-0 pt-4">
              <v-btn text color="rgba(255,255,255,0.6)" @click="clearForm">RESET</v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="#CFA22D"
                class="cyber-save-btn"
                :loading="loading"
                @click="save"
              >
                <v-icon left>mdi-content-save-all</v-icon> SIMPAN REKAP
              </v-btn>
            </v-card-actions>
          </v-form>
        </base-material-card>
      </v-col>

      <v-col cols="12" md="6">
        <base-material-card
          color="#CFA22D"
          icon="mdi-map-marker-radius"
          class="glass-card"
        >
          <template v-slot:heading>
            <div class="display-1 font-weight-black white--text">
              MAPPING TITIK KEJADIAN
            </div>
            <div class="subtitle-2 white--text opacity-7">
              Tentukan titik pusat bencana secara akurat
            </div>
          </template>
          <div class="map-wrapper">
            <div id="map-rekap" class="cyber-map-container"></div>
          </div>
        </base-material-card>
      </v-col>

      <v-col cols="12">
        <base-material-card
          color="#018C74"
          icon="mdi-table-clock"
          class="glass-card mt-6"
        >
          <template v-slot:heading>
            <v-row align="center" dense>
              <v-col cols="12" md="6"
                ><div class="display-1 font-weight-black white--text">
                  HISTORY REKAP BENCANA
                </div></v-col
              >
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Cari Desa, Kecamatan atau Jenis Kejadian..."
                  single-line
                  hide-details
                  rounded
                  dense
                  color="#CFA22D"
                />
              </v-col>
            </v-row>
          </template>

          <v-data-table
            :headers="headers"
            :items="rekapList"
            :search="search"
            :loading="loading"
            class="cyber-table"
          >
            <template v-slot:item.tanggal="{ item }">
              <span class="secondary-text">{{ item.tanggal }}</span>
            </template>
            <template v-slot:item.lokasi="{ item }">
              <div class="caption">{{ item.desa_bps }}, {{ item.kecamatan_bps }}</div>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn icon color="#018C74" @click="editItem(item)"
                ><v-icon small>mdi-pencil</v-icon></v-btn
              >
              <v-btn icon color="#ff5252" @click="deleteItem(item)"
                ><v-icon small>mdi-delete</v-icon></v-btn
              >
            </template>
          </v-data-table>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
const BASE_URL = "https://berkah.bondowosokab.go.id:5500";

export default {
  data: () => ({
    tab: null,
    search: "",
    loading: false,
    rekapList: [],
    kecamatanOptions: [],
    listBps: [],
    map: null,
    marker: null,
    headers: [
      { text: "TANGGAL", value: "tanggal" },
      { text: "KEJADIAN", value: "jenis_kejadian" },
      { text: "LOKASI", value: "lokasi" },
      { text: "MENINGGAL", value: "meninggal" },
      { text: "KERUGIAN (RP)", value: "taksiran_kerugian" },
      { text: "AKSI", value: "actions", align: "end", sortable: false },
    ],
    editedItem: {
      id: null,
      tanggal: "",
      jenis_kejadian: "",
      kecamatan_bps: null,
      desa_bps: null,
      jalan_dusun_rt_rw: "",
      koordinat: "",
      rumah_rusak_berat: 0,
      rumah_rusak_sedang: 0,
      rumah_rusak_ringan: 0,
      hutan_lahan_ha: 0,
      jumlah_rumah_rusak: 0,
      jumlah_kios: 0,
      taksiran_kerugian: 0,
      meninggal: 0,
      luka: 0,
      terdampak_kk: 0,
      jiwa_pria: 0,
      jiwa_perempuan: 0,
      lansia_pria: 0,
      lansia_wanita: 0,
    },
    defaultItem: {
      id: null,
      tanggal: "",
      jenis_kejadian: "",
      kecamatan_bps: null,
      desa_bps: null,
      jalan_dusun_rt_rw: "",
      koordinat: "",
      rumah_rusak_berat: 0,
      rumah_rusak_sedang: 0,
      rumah_rusak_ringan: 0,
      hutan_lahan_ha: 0,
      jumlah_rumah_rusak: 0,
      jumlah_kios: 0,
      taksiran_kerugian: 0,
      meninggal: 0,
      luka: 0,
      terdampak_kk: 0,
      jiwa_pria: 0,
      jiwa_perempuan: 0,
      lansia_pria: 0,
      lansia_wanita: 0,
    },
  }),

  computed: {
    filteredVillageOptions() {
      if (!this.editedItem.kecamatan_bps || this.kecamatanOptions.length === 0) return [];

      const selectedKec = this.kecamatanOptions.find(
        (k) => k.kode_bps == this.editedItem.kecamatan_bps
      );
      if (!selectedKec) return [];

      const targetName = selectedKec.nama_kecamatan.trim().toUpperCase();

      return this.listBps.filter((item) => {
        const bpsKecName = (item.nama_kecamatan || "").trim().toUpperCase();
        return bpsKecName === targetName;
      });
    },
  },

  watch: {
    "editedItem.kecamatan_bps"() {
      if (!this.editedItem.id) this.editedItem.desa_bps = null;
    },
    "editedItem.koordinat": function (newVal) {
      if (!newVal || newVal.indexOf(",") === -1) return;
      const [lat, lng] = newVal.split(",").map(Number);
      if (!isNaN(lat) && !isNaN(lng)) {
        if (this.marker) {
          this.marker.setLatLng([lat, lng]);
          this.map.panTo([lat, lng]);
        } else {
          this.createMarker(lat, lng);
        }
      }
    },
  },

  mounted() {
    this.fetchData();
    this.fetchKecamatan();
    this.fetchMasterData();
    this.initMap();
  },

  methods: {
    async fetchMasterData() {
      try {
        const response = await axios.get(`${BASE_URL}/api/android/master-init`, {
          headers: {
            "Bondowoso-Berkah":
              "7039338ec2fa8ac649760ddd8404b711b207479377c846d41d5d24b7b21beb97",
          },
        });
        this.listBps = response.data.response.data.data.bps || [];
      } catch (e) {
        console.error("Gagal Muat Master BPS", e);
      }
    },

    async fetchKecamatan() {
      try {
        const res = await axios.get(`${BASE_URL}/kecamatan`);
        if (res.data?.response?.data) this.kecamatanOptions = res.data.response.data;
      } catch (e) {
        console.error("Error Fetch Kecamatan", e);
      }
    },

    initMap() {
      setTimeout(() => {
        this.map = L.map("map-rekap", { zoomControl: false }).setView(
          [-7.9135, 113.8215],
          11
        );
        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png").addTo(this.map);
        this.map.on("click", (e) => {
          const { lat, lng } = e.latlng;
          this.editedItem.koordinat = `${lat.toFixed(6)},${lng.toFixed(6)}`;
          this.createMarker(lat, lng);
        });
      }, 500);
    },

    createMarker(lat, lng) {
      if (this.marker) this.map.removeLayer(this.marker);
      this.marker = L.marker([lat, lng], { draggable: true }).addTo(this.map);
      this.marker.on("dragend", (e) => {
        const { lat, lng } = e.target.getLatLng();
        this.editedItem.koordinat = `${lat.toFixed(6)},${lng.toFixed(6)}`;
      });
    },

    async fetchData() {
      this.loading = true;
      try {
        const res = await axios.get(`${BASE_URL}/master/rekap-bencana`);
        if (res.data && res.data.response && Array.isArray(res.data.response.data)) {
          this.rekapList = res.data.response.data;
        }
      } catch (e) {
        this.rekapList = [];
      } finally {
        this.loading = false;
      }
    },

    async save() {
      if (!this.editedItem.kecamatan_bps || !this.editedItem.desa_bps)
        return alert("Pilih Kecamatan & Desa!");
      this.loading = true;
      try {
        if (this.editedItem.id) {
          await axios.put(
            `${BASE_URL}/master/rekap-bencana/${this.editedItem.id}`,
            this.editedItem
          );
        } else {
          await axios.post(`${BASE_URL}/master/rekap-bencana`, this.editedItem);
        }
        this.fetchData();
        this.clearForm();
        alert("Data Tersimpan!");
      } catch (e) {
        alert("Gagal menyimpan!");
      } finally {
        this.loading = false;
      }
    },

    editItem(item) {
      this.editedItem = Object.assign({}, item);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    clearForm() {
      this.editedItem = Object.assign({}, this.defaultItem);
      if (this.marker) this.map.removeLayer(this.marker);
    },

    async deleteItem(item) {
      if (confirm("Hapus rekap ini?")) {
        await axios.delete(`${BASE_URL}/master/rekap-bencana/${item.id}`);
        this.fetchData();
      }
    },
  },
};
</script>

<style scoped>
.glass-card {
  background: rgba(0, 20, 15, 0.9) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(1, 140, 116, 0.3) !important;
}
.transparent-tabs {
  background: transparent !important;
  padding: 15px 0;
}
.cyber-map-container {
  height: 500px;
  width: 100%;
  border-radius: 8px;
}
.border-neon {
  border-top: 1px solid #018c74 !important;
  opacity: 0.3;
}
.cyber-text {
  text-shadow: 0 0 15px rgba(1, 140, 116, 0.6);
  color: white;
}
.cyber-save-btn {
  font-weight: bold !important;
  letter-spacing: 1px;
  color: #002616 !important;
}
.cyber-coord-field >>> input {
  color: #cfa22d !important;
  font-family: monospace;
}

.cyber-page,
.cyber-container,
.cyber-portal {
  background: transparent !important;
}

.cyber-title,
.cyber-text,
.cyber-id,
.cyber-desc,
.cyber-item-text {
  color: #1c2b28 !important;
  text-shadow: none !important;
}

.secondary-text {
  color: #018c74 !important;
  text-shadow: none !important;
}

.glass-card,
.cyber-card,
.cyber-dialog,
.cyber-dialog-card,
.cyber-modal,
.cyber-map-container,
.cyber-mapping-container,
.cyber-news-container,
.cyber-moments,
.cyber-carousel,
.cyber-agenda,
.cyber-sosmed-header,
.cyber-map-box,
.cyber-map {
  background: #ffffff !important;
  border: 1px solid #eef1f0 !important;
  backdrop-filter: none !important;
  color: #1c2b28 !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;
}

.dialog-header,
.dialog-header-gradient {
  background: #f4f7f6 !important;
  color: #1c2b28 !important;
  border-bottom: 1px solid #eef1f0 !important;
}

.dialog-header .white--text,
.dialog-header-gradient .white--text,
.cyber-dialog .white--text,
.cyber-dialog-card .white--text {
  color: #1c2b28 !important;
}

.dialog-neon-line,
.neon-line {
  background: linear-gradient(90deg, #018c74, #cfa22d, #018c74) !important;
}

.transparent-table,
.cyber-table,
.transparent-tabs {
  background: #ffffff !important;
  color: #1c2b28 !important;
}

.transparent-table >>> th,
.cyber-table >>> th {
  background: #f4f7f6 !important;
  color: #018c74 !important;
  font-weight: 800;
  border-bottom: 2px solid #018c74 !important;
}

.transparent-table >>> td,
.cyber-table >>> td {
  color: #1c2b28 !important;
  border-bottom: 1px solid #eef1f0 !important;
}

.transparent-table >>> .v-data-table__empty-wrapper,
.cyber-table >>> .v-data-table__empty-wrapper {
  color: #9aa6a3 !important;
}

.cyber-input,
.cyber-field,
.cyber-search,
.cyber-search-field,
.cyber-search-bar,
.cyber-input-mini,
.cyber-input-dense,
.cyber-input-highlight,
.cyber-input-coord,
.cyber-coord-field,
.cyber-select-dense,
.cyber-file-input,
.cyber-datepicker {
  color: #1c2b28 !important;
}

.cyber-input >>> .v-input__control,
.cyber-field >>> .v-input__control,
.cyber-search >>> .v-input__control,
.cyber-search-field >>> .v-input__control,
.cyber-search-bar >>> .v-input__control,
.cyber-input-mini >>> .v-input__control,
.cyber-input-dense >>> .v-input__control,
.cyber-input-highlight >>> .v-input__control,
.cyber-input-coord >>> .v-input__control,
.cyber-coord-field >>> .v-input__control,
.cyber-select-dense >>> .v-input__control,
.cyber-file-input >>> .v-input__control,
.cyber-datepicker >>> .v-input__control {
  background: #ffffff !important;
  border-radius: 10px;
}

.cyber-input >>> input,
.cyber-field >>> input,
.cyber-search >>> input,
.cyber-search-field >>> input,
.cyber-search-bar >>> input,
.cyber-input-mini >>> input,
.cyber-input-dense >>> input,
.cyber-input-coord >>> input,
.cyber-coord-field >>> input,
.cyber-datepicker >>> input,
.cyber-input >>> .v-label,
.cyber-field >>> .v-label,
.cyber-search >>> .v-label,
.cyber-search-field >>> .v-label,
.cyber-search-bar >>> .v-label,
.cyber-select-dense >>> .v-label,
.cyber-datepicker >>> .v-label {
  color: #1c2b28 !important;
}

.cyber-btn-add,
.cyber-add-btn,
.cyber-add-sosmed-btn {
  background: linear-gradient(135deg, #018c74 0%, #02b395 100%) !important;
  color: #ffffff !important;
  font-weight: 700;
  border: none !important;
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.25) !important;
}

.cyber-btn-save,
.cyber-save-btn {
  background: #018c74 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.25) !important;
}

.icon-scan-box,
.icon-scan-frame,
.preview-container,
.preview-hex-frame,
.preview-mini-frame,
.preview-scanner {
  background: #f4f7f6 !important;
  border: 1px solid #eef1f0 !important;
}

.preview-tag {
  background: #eaf6f3 !important;
  color: #018c74 !important;
  border: 1px solid rgba(1, 140, 116, 0.3) !important;
}

.scan-overlay {
  display: none !important;
}

.shadow-glow,
.shadow-glow-gold,
.shadow-glow-teal {
  box-shadow: 0 6px 16px rgba(1, 140, 116, 0.15) !important;
}

.action-glow.edit-btn,
.action-glow.delete-btn {
  background: transparent !important;
}


.v-data-table >>> .white--text {
  color: #1c2b28 !important;
}
.plain-description {
  color: #4a5a57 !important;
}

</style>
